import type { Modification } from '../../types';
import { checkIfDressingIngredient } from '../index';

// ─────────────────────────────────────────────────────────────────────────────

export function resetDressingQuantity(
  modification: Modification,
): Modification {
  const isDressingIngredient = checkIfDressingIngredient(modification);

  if (!isDressingIngredient) {
    return modification;
  }

  return { ...modification, quantity: 1 };
}
